import { omit } from "lodash-es";
import * as SL from "slate";
import { ReactEditor } from "slate-react";
import {
  CustomEditor,
  isValidSelection,
  getElementsByType,
  Marks
} from "../../../../duck";
import { CheckIsMarkActive, RemoveMark, ToggleMarkFunction } from "./types";

export const restoreSelection = (
  editor: CustomEditor,
  selection = editor.selection
) => {
  ReactEditor.focus(editor);

  if (isValidSelection(editor, selection)) {
    SL.Transforms.setSelection(editor, selection);
  } else if (editor.selection) {
    SL.Transforms.setSelection(editor, editor.selection);
  }
};

export const checkIsMarkActive: CheckIsMarkActive = (editor, format) => {
  // actually checked if mark is Boolean and Active
  const marks: Marks | null = editor.getMarks();
  return marks?.[format] === true;
};

const getFullySelectedListItem = (editor: CustomEditor) => {
  // Select full list item inside redactor to set mark styles
  if (!editor.selection) return null;

  const listItem = getElementsByType(editor, "list-item").pop();

  if (!listItem) return false;
  const [listItemElement, listItemPath] = listItem;

  const start = SL.Editor.start(editor, listItemPath);
  const end = SL.Editor.end(editor, listItemPath);
  const isSelectedFully =
    (SL.Point.equals(editor.selection.anchor, start) &&
      SL.Point.equals(editor.selection.focus, end)) ||
    (SL.Point.equals(editor.selection.anchor, end) &&
      SL.Point.equals(editor.selection.focus, start));
  return isSelectedFully ? listItemElement : null;
};

export const removeMark: RemoveMark = (editor, format) => {
  const listItem = getFullySelectedListItem(editor);

  if (listItem) {
    SL.Transforms.setNodes(editor, { marks: omit(listItem.marks, format) });
  }

  SL.Editor.removeMark(editor, format);
};

export const applyMarks = (editor: CustomEditor, marks: Marks) => {
  const listItem = getFullySelectedListItem(editor);

  if (listItem) {
    SL.Transforms.setNodes(editor, { marks: { ...listItem.marks, ...marks } });
  }

  Object.entries(marks).forEach(([key, markValue]) => {
    editor.addMark(key, markValue);
  });
};

export const toggleMark: ToggleMarkFunction = (editor, format, value) => {
  const isActive = checkIsMarkActive(editor, format);

  if (isActive) {
    removeMark(editor, format);
  } else {
    applyMarks(editor, { [format]: value ?? true });
  }
};
